export function WhatsAppMessage(tel: string, text: string) {
    let encodedText = encodeURI(text)
    return ` https://wa.me/${tel}?text=${encodedText}`
}

